import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import NetworkCheckOutlinedIcon from '@mui/icons-material/NetworkCheckOutlined';
import routes from '../../../Utils/routes';
interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  handleClose?: any;
  name?: string; // <-- Add this
}
interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  handleClose?: any;
}

const MobileNavTabs: React.FC<SideNavProps> = ({ handleListClick, handleClose }) => {
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter(Boolean);
  const [openInfoHub, setOpenInfoHub] = useState(
    ['resources', 'business%20directory'].includes(getFirstPath[0])
  );

  const iconColor = '#2C60AA';

  const navigationItems = [
    { icon: <HomeOutlinedIcon sx={{ color: iconColor }} />, label: 'Home', link: routes.home, name: 'home' },
    { icon: <PersonOutlineOutlinedIcon sx={{ color: iconColor }} />, label: 'My Profile', link: routes.myProfile, name: 'myProfile' },
    { icon: <FeedOutlinedIcon sx={{ color: iconColor }} />, label: 'Feed', link: routes.myFeed, name: 'myFeed' },
    { icon: <EventOutlinedIcon sx={{ color: iconColor }} />, label: 'Events', link: routes.events, name: 'events' },
    { icon: <WorkOutlineOutlinedIcon sx={{ color: iconColor }} />, label: 'Jobs', link: routes.jobs, name: 'jobs' },
    { icon: <SchoolOutlinedIcon sx={{ color: iconColor }} />, label: 'Mentorship', link: routes.mentorship, name: 'mentorship' },
    { icon: <PaymentsOutlinedIcon sx={{ color: iconColor }} />, label: 'Fundraise', link: routes.fundraise, name: 'fundraise' },
    { icon: <NetworkCheckOutlinedIcon sx={{ color: iconColor }} />, label: 'Network', link: routes.network, name: 'network' },
    { icon: <GroupsOutlinedIcon sx={{ color: iconColor }} />, label: 'Groups', link: routes.groups, name: 'groups' },
    {
      icon: <MenuBookOutlinedIcon sx={{ color: iconColor }} />,
      label: 'Info Hub',
      name: 'infohub',
      isDropdown: true,
      children: [
        // { label: 'Photos', link: routes.photos, name: 'photos', icon: <PermMediaOutlinedIcon sx={{ color: iconColor }} /> },
        { label: 'Business Directory', link: routes.businessdirectory, name: 'business%20directory', icon: <ComputerOutlinedIcon sx={{ color: iconColor }} /> },
        { label: 'Resources', link: routes.resources, name: 'resources', icon: <MenuBookOutlinedIcon sx={{ color: iconColor }} /> },
      ],
    },
    { icon: <PermMediaOutlinedIcon sx={{ color: iconColor }} />, label: 'Photos', link: routes.photos, name: 'photos' },
    { icon: <FeedOutlinedIcon sx={{ color: iconColor }} />, label: 'Survey', link: routes.survey, name: 'survey' },
    { icon: <SettingsOutlinedIcon sx={{ color: iconColor }} />, label: 'Service & Support', link: routes.service, name: 'service' },
    { icon: <SettingsOutlinedIcon sx={{ color: iconColor }} />, label: 'Settings', link: routes.settings, name: 'settings' },
    { icon: <ModeCommentOutlinedIcon sx={{ color: iconColor }} />, label: 'Chat', link: routes.chats, name: 'chats' },
  ];

  const handleNavigation = (link: string, index: number) => {
    if (handleClose) handleClose();
    setTimeout(() => handleListClick(link, index), 50);
  };

  const isInfoHubActive = navigationItems.find(item => item.isDropdown)?.children?.some(sub => getFirstPath[0] === sub.name);

  return (
    <>
      <Box sx={{ flex: 1, overflowY: 'auto', height: 'calc(95vh - 230px)' }}>
        {navigationItems.map((item, index) => {
          if (item.isDropdown) {
            return (
              <div key={item.label}>
                <ListItemButton
                  onClick={() => setOpenInfoHub(!openInfoHub)}
                  sx={{
                    py: 1.5,
                    pl: 2,
                    pr: 1,
                    borderRadius: '4px',
                    '&:hover': { backgroundColor: '#f5f8ff' },
                    ...(isInfoHubActive && { backgroundColor: '#f5f8ff' }),
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    sx={{ m: 0, '& .MuiTypography-root': { fontSize: 16, fontWeight: isInfoHubActive ? 500 : 400, color: '#373A45' } }}
                  />
                  {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                  {item.children.map(subItem => {
                    const isSubActive = getFirstPath[0] === subItem.name;
                    return (
                      <ListItemButton
                        key={subItem.label}
                        onClick={() => handleNavigation(subItem.link, index)}
                        sx={{
                          py: 1.5,
                          pl: 4,
                          pr: 1,
                          borderRadius: '4px',
                          '&:hover': { backgroundColor: '#f5f8ff' },
                          ...(isSubActive && { backgroundColor: '#f5f8ff' }),
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: 36 }}>{subItem.icon}</ListItemIcon>
                        <ListItemText
                          primary={subItem.label}
                          sx={{ m: 0, '& .MuiTypography-root': { fontSize: 16, fontWeight: isSubActive ? 500 : 400, color: '#373A45' } }}
                        />
                      </ListItemButton>
                    );
                  })}
                </Collapse>
              </div>
            );
          } else {
            const isActive = getFirstPath[0] === item.name;
            return (
              <ListItemButton
                key={index}
                onClick={() => handleNavigation(item.link || '', index)}
                sx={{
                  py: 1.5,
                  pl: 2,
                  pr: 1,
                  borderRadius: '4px',
                  '&:hover': { backgroundColor: '#f5f8ff' },
                  ...(isActive && { backgroundColor: '#f5f8ff' }),
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{ m: 0, '& .MuiTypography-root': { fontSize: 16, fontWeight: isActive ? 500 : 400, color: '#373A45' } }}
                />
              </ListItemButton>
            );
          }
        })}
      </Box>

      <Box
        sx={{
          borderTop: '1px solid #EAEFFF',
          mt: 2,
          pt: 2,
          px: 1,
          position: 'fixed',
          bottom: 0,
          width: 'calc(100% - 32px)',
          backgroundColor: 'white',
        }}
      >
        <ListItemButton
          onClick={() => handleNavigation(routes.landingpage, navigationItems.length + 1)}
          sx={{ py: 1.5, pl: 2, pr: 1, borderRadius: '4px', '&:hover': { backgroundColor: '#f5f8ff' } }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <SettingsOutlinedIcon sx={{ color: iconColor }} />
          </ListItemIcon>
          <ListItemText primary="Logout" sx={{ m: 0, '& .MuiTypography-root': { fontSize: 16, color: '#373A45' } }} />
        </ListItemButton>
      </Box>
    </>
  );
};

export default MobileNavTabs;
